import { MASTER_DATA_SERVER } from "swfrontend/AppConfigs";

export const ROUTES = {
  CUSTOMER_ROUTE: "customer",
  MASTER_ROUTE:`${MASTER_DATA_SERVER.API_PREFIX}/${MASTER_DATA_SERVER.MASTER_ROUTE}`,
  BASE_ROUTE:`${MASTER_DATA_SERVER.API_PREFIX}`
};

export const SERVER = MASTER_DATA_SERVER;
export const BASE_URL = `${process.env.REACT_APP_SERVER_PROTOCOL}://${SERVER.SERVER_URL}:${SERVER.PORT}`;
export const CUSTOMER_DATA_SERVER_URL = ((SERVER) =>
  `/${SERVER.API_PREFIX}/${ROUTES.CUSTOMER_ROUTE}`)(MASTER_DATA_SERVER);

/* Header details with Auth token  */
export const HEADER_JSON = {
  Accept: "application/json",
  Authorization: JSON.parse(
    localStorage.getItem(`${process.env.REACT_APP_TOKEN_PREFIX}-auth-token`)
  ),
  source: "workflow",
  req: "list",
};
